import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'kepler/lib/components/Container';
import Banner from './ToolsBanner';
import MyAppsList from './MyAppsList';
import RedirectBanner from './AppCenter/components/RedirectBanner';
import { RouteWithSubRoutes } from '../../routes/routeHelpers';
import { impressionTrackManual } from '../lib/tracking';
import MyRecommendations from './MyRecommendations';

const MyApps = props => {
  const { activeKey, dispatch, fetchRecommendedTools, path, routes } = props;

  useEffect(() => {
    // Fetch recommendation tools from smartrec
    dispatch(fetchRecommendedTools());
  }, []);

  useEffect(() => {
    impressionTrackManual(props);
  }, [activeKey]);

  return (
    <div id="merchanthub-apps-wrapper">
      <Banner />
      <Container id="merchanthub-apps">
        {path.includes('?redirect=true') && <RedirectBanner />}
        <MyRecommendations />
        {routes &&
          routes.map((route, i) => <RouteWithSubRoutes index={i} {...route} />)}
        <MyAppsList {...props} />
      </Container>
    </div>
  );
};

MyApps.propTypes = {
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  favorites: PropTypes.array,
  activeKey: PropTypes.string,
  app: PropTypes.object,
  dispatch: PropTypes.func,
  updateApp: PropTypes.func,
  updatePath: PropTypes.func,
  recordClick: PropTypes.func,
  recordImpression: PropTypes.func,
  routes: PropTypes.array.isRequired,
  tracking: PropTypes.object,
  fetchTools: PropTypes.func,
  fetchRecommendedTools: PropTypes.func,
  toggleToolFavorite: PropTypes.func,
  tools: PropTypes.object,
  search: PropTypes.object,
  recommendations: PropTypes.array,
  path: PropTypes.string
};

export default MyApps;
